import { makeStyles } from "@material-ui/core";

export const PricingByLotStyle = makeStyles((theme) => ({
	vendorSections: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing(1),
		marginTop: theme.spacing(2),
		paddingBottom: theme.spacing(1),
		height: '100%',
		minHeight: 0,
		overflowY: 'auto',
	},
	vendorSection: {
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: theme.shape.borderRadius,
		overflow: 'hidden',
		backgroundColor: theme.palette.common.white,
		width: '100%',
		boxSizing: 'border-box',
	},
	vendorAccordionContent: {
		margin: 0,
	},
	vendorAccordion: {
		overflow: 'visible !important',

		'& .MuiCollapse-root, & .MuiCollapse-wrapper, & .MuiCollapse-wrapperInner': {
			overflow: 'visible !important',
		},

		boxShadow: 'none',
		margin: 0,
		'&:before': {
			display: 'none',
		},
	},
	vendorTableCompact: {
		padding: theme.spacing(0, 1, 1, 1),
		boxShadow: 'none',
		height: 'var(--table-height) !important',
		minHeight: '0px !important',
	},
	badgeCell: {
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
	},
	badge: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: theme.spacing(0.5, 2),
		borderRadius: 999,
		backgroundColor: theme.palette.action.hover,
		color: theme.palette.text.primary,
		minHeight: theme.spacing(4),
		whiteSpace: 'nowrap',
	},
	badgeDisabled: {
		color: theme.palette.text.disabled,
	},
	badgeInteractive: {
		cursor: 'pointer',
	},
	tooltip: {
		padding: theme.spacing(1),
		minWidth: theme.spacing(28),
	},
	tooltipTitle: {
		fontWeight: 600,
		marginBottom: theme.spacing(1),
	},
	tooltipRow: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: theme.spacing(3),
		padding: theme.spacing(1, 0),
		borderTop: `1px solid ${theme.palette.divider}`,
		'&:first-of-type': {
			borderTop: 'none',
			paddingTop: 0,
		},
		'&:last-of-type': {
			paddingBottom: 0,
		},
	},
	tooltipPrice: {
		fontWeight: 600,
	},
}));
